import { EmailTemplateI } from "../Types/state/emailTemplate.state";

// Reducer Types
export interface State {
  faqList: any;
  emailTemplateList: any;
  emailTemplateDetails: any;
  singleEmailTemplate: any; // Replace `any` with a more specific type if available
}

export const emailReducer = (
  state: State = {
    faqList: [],
    emailTemplateList: [],
    emailTemplateDetails: {},
    singleEmailTemplate: {},
  },
  action: any
): State => {
  switch (action.type) {
    case "EMAIL_TEMPLATE_LIST_SUCCESS":
      return {
        ...state,
        emailTemplateList:
          action.payload?.page == 1 ? action.payload.data : [...state?.emailTemplateList, ...action?.payload?.data],
        // emailTemplateCount: action.payload.count,
      };
    case "EMAIL_TEMPLATE_DETAILS_SUCCESS":
      return {
        ...state,
        emailTemplateDetails: action.payload,
      };
    case "SINGLE_EMAIL_TEMPLATE_SUCCESS":
      return {
        ...state,
        singleEmailTemplate: action.payload,
      };
    default:
      return state;
  }
};
